import React,{useEffect} from "react";
import {Helmet} from 'react-helmet';
import Style from "../styles/About.module.css";
import dinoImg from '../imgs/About/dino.jpg';
import img1 from '../imgs/About/family.jpg';
import img2 from '../imgs/About/friend.jpg';
import img3 from '../imgs/About/workers.jpg';

const About = () =>{
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return(
        <div>
            <Helmet>
            <title>About Us - Dino Constructions</title>
            <meta name="description" content="Learn more about Dino Construction, a family owned construction and renovation company serving Asheville and surrounding areas." />
            <meta property="og:title" content="About Us - Dino Constructions" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://dinoconstructions.com/AboutUs" />
            <link rel="canonical" href="https://dinoconstructions.com/AboutUs"/>
            <meta property="og:description" content="Learn more about Dino Construction, a family owned construction and renovation company serving Asheville and surrounding areas." />
      </Helmet>
            <section className={Style.Content1}>
                <div className={Style.Content1Intro}>
                    <p>About Dino Construction</p>
                    <h1>Family owned. Locally trusted. Built with care.</h1>
                    <span>Construction and renovation work for homeowners across Asheville and surrounding communities.</span>
                </div>
            </section>

            <section className={Style.Content2}>
                <div className={Style.Content2PartA}>
                    <div className={Style.PartAInfo}>
                        <p className={Style.sectionKicker}>The owner</p>
                        <h2>Meet Secundino</h2>
                        <p>Dino Construction is a family owned business led by Secundino, whose work is shaped by hands-on experience, practical problem solving, and a strong eye for detail. Since 2010, the company has helped local homeowners with concrete, roofing, painting, decks, fences, stone patios, and block foundation projects.</p>
                        <p>Every project starts with listening. The goal is simple: understand what the homeowner needs, explain the work clearly, and deliver a result that feels solid, clean, and built to last.</p>
                    </div>
                </div>
                <div className={Style.Content2PartB}>
                    <img src={dinoImg} alt="Owner of Dino Construction" loading="lazy" decoding="async" width="640" height="800"></img>
                </div>
            </section>

            <section className={Style.Content3}>
                <div className={Style.Content3PartA}>
                    <p className={Style.sectionKicker}>What guides the work</p>
                    <h2>Quality work starts with trust</h2>
                    <p>We believe good construction is more than tools and materials. It is communication, respect for the property, attention to detail, and doing the work the right way even when nobody is watching.</p>
                </div>
                <div className={Style.ValueGrid}>
                    <div>
                        <span>01</span>
                        <h3>Clear Communication</h3>
                        <p>We keep the project practical and understandable from the first conversation to the final walkthrough.</p>
                    </div>
                    <div>
                        <span>02</span>
                        <h3>Careful Craftsmanship</h3>
                        <p>Every service is handled with attention to durability, finish, and the details that affect daily use.</p>
                    </div>
                    <div>
                        <span>03</span>
                        <h3>Local Relationships</h3>
                        <p>We are proud to serve homeowners in Asheville and nearby areas with work that supports the community.</p>
                    </div>
                </div>
            </section>

            <section className={Style.Content4}>
                <div className={Style.Content4PartA}>
                    <img className={Style.img1} src={img1} alt="Dino Construction family" loading="lazy" decoding="async" width="640" height="420"></img>
                    <img className={Style.img2} src={img2} alt="Dino Construction customer relationship" loading="lazy" decoding="async" width="640" height="420"></img>
                    <img className={Style.img3} src={img3} alt="Dino Construction crew" loading="lazy" decoding="async" width="640" height="420"></img>
                </div>
                <div className={Style.Content4PartB}>
                    <div className={Style.PartBInfo}>
                        <p className={Style.sectionKicker}>Why it matters</p>
                        <h2>Building strong relationships</h2>
                        <p>At Dino Construction, strong relationships are part of the work. We take time to understand your vision, explain the project, and stay focused on a result you can feel confident about.</p>
                        <p>From the first consultation to the final walkthrough, our team works to make the process straightforward, respectful, and centered on your home.</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
